'use client';

import { useTotem } from '@/app/(users)/totem-by-slug/[slug]/providers/totem-provider';
import { calculateCartItemTotal, formatTotemPrice } from '@/app/(users)/totem-by-slug/[slug]/utils/totem-price';

export function TotemCheckoutSummary() {
  const { cart } = useTotem();

  return (
    <div className="flex h-full flex-col min-h-0">
      <h3 className="mb-4 shrink-0 text-xs font-bold tracking-wider text-muted-foreground uppercase">Resumen</h3>

      <div className="flex-1 min-h-0 overflow-y-auto pr-2">
        <ul className="flex flex-col gap-4 text-sm font-medium">
          {cart.items.map(item => {
            const rowTotal = calculateCartItemTotal(item);
            return (
              <li
                key={item.id}
                className="flex justify-between gap-4 border-b border-border/50 pb-4 last:border-0 last:pb-0"
              >
                <span className="flex-1 text-muted-foreground">
                  <span className="text-foreground mr-1">{item.quantity}x</span>
                  {item.name}
                </span>
                <span className="text-orange-500 min-w-[80px] text-right font-bold">{formatTotemPrice(rowTotal)}</span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mt-6">
        <div className="h-1.5 w-full bg-muted-foreground/30 rounded-full mb-4"></div>
        <div className="flex items-end justify-between">
          <span className="text-xl font-bold">Total</span>
          <span className="text-4xl font-extrabold text-orange-500">{formatTotemPrice(cart.total)}</span>
        </div>
      </div>
    </div>
  );
}
